// eslint-disable-next-line import/prefer-default-export
export const retrieveSimulations = 'RETRIEVE_SIMULATIONS';
export const retrieveSimulationResult = 'RETRIEVE_SIMULATION_RESULT';
